import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsxs("g", {
        fill: "currentColor",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 7.5c-1.6569 0-3-1.3431-3-3s1.3431-3 3-3 3 1.3432 3 3-1.3431 3-3 3"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "12",
                rx: "3",
                ry: "3",
                transform: "rotate(90 12 12)"
            }),
            /*#__PURE__*/ _jsx("ellipse", {
                cx: "12",
                cy: "19.5",
                rx: "3",
                ry: "3",
                transform: "rotate(90 12 19.5)"
            })
        ]
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "StatusProcessing", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
